module.exports = __webpack_public_path__ + "static/media/icon_top_arrow_B.87085654.svg";